import { render, staticRenderFns } from "./OfflineDashboardPage.vue?vue&type=template&id=0fae63b6"
import script from "./OfflineDashboardPage.vue?vue&type=script&lang=js"
export * from "./OfflineDashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports